import { createFileRoute } from '@tanstack/react-router'
import { JobsView } from 'pages/jobsView/JobsView'

export const Route = createFileRoute('/jobs')({
  component: JobsView,
  staticData: {
    title: 'Jobs',
    layout: {
      enableScrolling: true,
    },
  },
})
